import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';

async function loginUser(credentials) {
  return fetch(process.env.REACT_APP_NERTHUS_API_URL + '/users/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  })
    .then(data => data.json())
 }

export function Login({ setToken }) {

  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [successLogin, setSuccesLogin] = useState(true);

  const handleSubmit = async e => {
    e.preventDefault();
    setSuccesLogin(true);
    const tokenData = await loginUser({
      username,
      password
    });
    if (!tokenData.data || !tokenData.data.length) {
      setSuccesLogin(false);
    }
    setToken(tokenData);
  }

  return (
    <>
    <div className="Auth-form-container products">
      <form className="Auth-form" onSubmit={handleSubmit}>
        <div className="Auth-form-content">
          <div className="text-center">
                  <img src="logo-nerthus.png" alt='logo' style={{ width: '250px' }}/>
                  <h4 className="mt-1 mb-4 pb-1">We are The Nerthus Team</h4>
          </div>
          <div className="form-group">
            <label style={{ fontSize: '20px' }}>Username</label>
            <input
              type="username"
              className="form-control"
              placeholder="Enter Username"
              onChange={e => setUserName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label style={{ fontSize: '20px' }}>Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter password"
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <div className="d-grid gap-2 mt-3">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
        </div>
      </form>   
    </div>
        {!successLogin
          ? (<Alert key='danger' variant='danger'>
            ¡Credenciales Incorrectas, intenta de Nuevo!
            </Alert>)
          : ""
        }
    </>
  );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
}